import { db } from './db'
import type { Plan } from '$lib/types'

export type NewPlan = Omit<Plan, 'id'>

export async function add(record: NewPlan): Promise<number> {
  return db.plans.add(record as Plan)
}

export async function get(id: number): Promise<Plan | undefined> {
  const record = await db.plans.get(id)
  // Plans persisted before the in-memory `version` counter existed lack the
  // field. Default it to 0 on read so the editor's bump arithmetic never
  // sees `undefined`. No Dexie migration needed — the schema is index-only;
  // the data shape is opaque, so adding a field round-trips for free.
  if (record && typeof record.version !== 'number') record.version = 0
  return record
}

export async function list(): Promise<Plan[]> {
  return db.plans.orderBy('updatedAt').reverse().toArray()
}

export async function listForImport(importedCityId: number): Promise<Plan[]> {
  return db.plans.where('importedCityId').equals(importedCityId).toArray()
}

export async function update(id: number, changes: Partial<Plan>): Promise<void> {
  await db.plans.update(id, { ...changes, updatedAt: Date.now() })
}

export async function rename(id: number, name: string): Promise<void> {
  await update(id, { name })
}

export async function remove(id: number): Promise<void> {
  await db.plans.delete(id)
}
